import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PgProfileEditorService } from '../pg-profile-editor.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-pg-edit-profile',
    templateUrl: './pg-edit-profile.component.html',
    styleUrls: ['./pg-edit-profile.component.scss'],
    standalone: false
})
export class PgEditProfileComponent implements OnInit, OnDestroy {

    constructor(private pgProfileEditorService:PgProfileEditorService, private modalService:NgbModal) { }

    @ViewChild('editProfileTemplate') editProfileTemplate: ElementRef;

    private _editProfileModalRef:NgbModalRef = null;

    private _serviceSubscription:Subscription = null;

    ngOnInit(): void {
        this._serviceSubscription = this.pgProfileEditorService.request.subscribe((data) => {
            if(data.fn == 'edit-profile') {
                if(this._editProfileModalRef == null) {
                    let _cOptions:NgbModalOptions = {
                        backdrop: 'static',
                        keyboard: false,
                        windowClass: 'PGEditProfileModal',
                        size: 'xl'
                    }
        
                    this._editProfileModalRef = this.modalService.open(this.editProfileTemplate, _cOptions);
                    this._editProfileModalRef.result.then(() => {
                        this._editProfileModalRef = null;
                    }, () => {
                        this._editProfileModalRef = null;
                    })
                }
            }
        })
    }

    ngOnDestroy(): void {
        this._serviceSubscription.unsubscribe()
    }

    closeEditor() {
        this._editProfileModalRef.close();
    }
}
